<div class="big-container">
  <div class="side-left">
    <app-cats-search></app-cats-search>
  </div>
  <div class="side-right">
    <div *ngIf="loadedBreeds && loadedBreeds.length < 1" class="spinner">
      <div class="double-bounce1"></div>
      <div class="double-bounce2"></div>
    </div>
    <div class="row">
      <ul *ngIf="loadedBreeds && loadedBreeds.length >= 1">
        <li
          *ngFor="let breed of loadedBreeds"
          routerLinkActive="active"
          routerLink="{{ breed.id }}"
          class="cat-breed"
        >
          <a class="column-left"
            ><div class="breed-name">{{ breed.name }}</div>
            <div class="breed-description">Energy level:</div>
          </a>
          <div class="column-right">
            <img
              src="../../../assets/{{ breed.energy_level }}.svg"
              alt="Breed rating"
              class="rating-img"
            />
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
